import { Button, Popover, Select, Spin, Table } from "antd";
import {
  generateAbsencePdfByYear,
  generateAbsencePdfBySemester,
  getAllStudentByClass,
  getJustificatifById,
  getStudentAbsenceByYear,
} from "../../../api/etudiants";
import { buildPermissionContext } from "../../../core/common/autorisations/permissionsMap";
import { Resource } from "../../../core/common/autorisations/permissionsMap";
import { Action } from "../../../core/common/autorisations/permissionsMap";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import dayjs from "dayjs";
import "dayjs/locale/fr";
import { getSessionsByYear } from "../../../api/settingEDT";
import ReportAbsenceBubble from "./reportAbsenceBubble";
import { getFileAttachementByEntityId } from "../../../api/fileAttachement";
import { getAllEvaluationPeriodByLevel } from "../../../api/generalParam";
import { getLateByStudent } from "../../../api/late";
import AnnuelAbsenceReportApercuModal from "./reportAbsenceYear_apercu_modal";
import { getAllClass } from "../../../api/pedagogicElement";
import Avvvatars from "avvvatars-react";
import DashboardMenu from "../../user/admin/dashboardMenu";
import InfosAlertYearDisabled from "../../../core/common/alerts/infosAlertYearDisabled";

const StudentAbsencePage = () => {
  const { selectedYear } = useAcademicYear();

  const [allClass, setAllClass] = useState<any[]>([]);
  const [selectedClass, setSelectedClass] = useState<any>();
  const [allStudents, setAllStudents] = useState<any[]>([]);
  const [selectedStudent, setSelectedStudent] = useState<any>(null);
  const selectedStudentId =
    selectedStudent?.StudentProfil?.id ?? selectedStudent?.id ?? "";
  const [selectedPeriod, setSelectedPeriod] = useState<any>();
  const [loading, setLoading] = useState<{
    main: boolean;
    annuel: boolean;
    semester: boolean;
    students: boolean;
  }>({
    main: false,
    annuel: false,
    semester: false,
    students: false,
  });
  const [evaluationPeriods, setEvaluationPeriods] = useState<any[]>([]);

  const [absences, setAbsences] = useState<any[]>([]);
  const [lates, setLates] = useState<any[]>([]);
  const [allSessions, setAllSessions] = useState<any[]>([]);

  const [popoverVisible, setPopoverVisible] = useState<any>({});

  const [totals, setTotals] = useState<any>();

  const [pdfBlobUrl, setPdfBlobUrl] = useState<string>("");
  const [annuelReportVisible, setAnnuelReportVisible] =
    useState<boolean>(false);
  const [semesterReportVisible, setSemesterReportVisible] =
    useState<boolean>(false);
  // Fonction pour savoir si le jour appartient à la période d'évaluation
  const isInPeriod = (dateStr: string, period: any) => {
    if (!period) return false;
    const d = dayjs(dateStr);
    return (
      d.isAfter(dayjs(period.startDate).subtract(1, "day")) &&
      d.isBefore(dayjs(period.endDate).add(1, "day"))
    );
  };

  // Fonction pour calculer la somme des absences pour une période donnée
  const sumForPeriod = (field: any, period: any, absences: any[]) =>
    absences.reduce(
      (acc: number, rec: any) =>
        acc + (isInPeriod(rec?.date_course, period) ? rec[field] || 0 : 0),
      0,
    );

  const fetchAllClassByYear = async () => {
    try {
      if (!selectedYear) return;
      const response = await getAllClass(
        selectedYear?.id,
        buildPermissionContext(Resource.STUDENT_ABSENCE, Action.READ),
      );
      const classes =
        (response.data || []).slice().sort((a: any, b: any) => {
          const levelCompare = a.Level.label.localeCompare(
            b.Level.label,
            "fr",
            { numeric: true },
          );
          if (levelCompare !== 0) return levelCompare;
          return a.label.localeCompare(b.label, "fr", { numeric: true });
        }) || [];
      // console.log("Classes: ",classes)
      setAllClass(classes);
      if (classes.length > 0) {
        setSelectedClass(classes[0]);
      } else {
        setSelectedClass(undefined);
      }
    } catch (error: any) {
      // console.log("Erreur lors de la récupération des classes:", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const fetchStudentsByClass = async () => {
    try {
      if (!selectedClass?.id) return;
      setLoading({
        ...loading,
        students: true,
      });
      const res = await getAllStudentByClass(
        selectedClass.id,
        buildPermissionContext(Resource.STUDENT_ABSENCE, Action.READ),
      );
      const students = res.data || [];
      setAllStudents(students);
      setSelectedStudent(null);
    } catch (error: any) {
      // console.log("Erreur lors de la récupération des étudiants:", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setLoading({
        ...loading,
        students: false,
      });
    }
  };

  const fetchAllEvaluationPeriodByLevel = async () => {
    try {
      const response = await getAllEvaluationPeriodByLevel(
        selectedClass?.Level?.id,
        buildPermissionContext(Resource.STUDENT_ABSENCE, Action.READ),
      );
      // console.log("All evaluation period: ", response);
      setEvaluationPeriods(response.data);
    } catch (error: any) {
      // console.log(
      //   "Erreur lors de la récupération des périodes d'évaluation:",
      //   error,
      // );
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // Fonction pour charger les infos du rapport de retrad de l'étudiant
  const loadData = async () => {
    try {
      const lates = await getLateByStudent(
        selectedStudentId,
        selectedClass?.id,
        buildPermissionContext(Resource.STUDENT_ABSENCE, Action.READ),
      );

      // Build a map: date → count of lates for that date
      const latesByDate = lates.data?.reduce(
        (acc: any, item: any) => {
          const date = dayjs(item?.CourseVersionEDT?.date_course).format(
            "YYYY-MM-DD",
          );
          acc[date] = {
            ...item,
            date_course: date,
            total_late: (acc[date]?.total_late || 0) + 1,
          };
          return acc;
        },
        {} as Record<string, number>,
      );

      // Transformer l'objet en tableau de valeurs
      const formattedLates = Object.values(latesByDate).sort(
        (a: any, b: any) =>
          new Date(a.date_course).getTime() - new Date(b.date_course).getTime(),
      );
      setLates(formattedLates || []);
      // console.log("Formatted lates: ", formattedLates);

      const response = await getStudentAbsenceByYear(
        selectedClass?.id,
        selectedStudentId,
        buildPermissionContext(Resource.STUDENT_ABSENCE, Action.READ),
      );
      // Regrouper les absences par date
      // 1) enrich each absence with its justificatif (parallel fetch)
      const enriched = await Promise.all(
        response.data.map(async (item: any) => {
          if (!item?.id_justificatif) return item;
          // récupérer les justificatif de l'étudiant
          const { data: justificatif } = await getJustificatifById(
            item.id_justificatif,
            buildPermissionContext(Resource.STUDENT_ABSENCE, Action.READ),
          );

          // récupérer les fichiers jointes au justificatif
          const { data: files } = await getFileAttachementByEntityId(
            item.id_justificatif,
            "JustificationAbsenceStudent",
            buildPermissionContext(Resource.STUDENT_ABSENCE, Action.READ),
          );

          // ajouter les fichiers jointes au justificatif
          justificatif.existingFiles = files || [];

          // tableau des absences liées au justificatif
          justificatif.linkedAbsenceIds =
            response.data
              .filter(
                (abs: any) =>
                  abs.id_justificatif === item.id_justificatif &&
                  abs.id !== item.id,
              )
              .map((abs: any) => abs.id) || [];
          return { ...item, justificatif: justificatif || null };
        }),
      );
      // console.log("ABSENCE ENRICHED: ", enriched);
      // 2) group by date
      const groupedByDate = enriched.reduce((acc: any, curr: any) => {
        const date = curr?.CourseVersionEDT?.date_course;
        if (!date) return acc;

        if (!acc[date]) {
          acc[date] = {
            date_course: date,
            absence_remark: curr.absence_remark || "",
            total_absence: 0,
            justified_absence: 0,
            unjustified_absence: 0,
            late_absence:
              (
                formattedLates.find(
                  (item: any) => item.date_course === date,
                ) as any
              )?.total_late || 0,
            sessions: [],
          };
        }
        // merge remarks
        if (
          curr.absence_remark &&
          !acc[date].absence_remark.includes(curr.absence_remark)
        ) {
          acc[date].absence_remark +=
            (acc[date].absence_remark ? " | " : "") + curr.absence_remark;
        }

        // counters
        acc[date].total_absence += curr?.id_session?.length || 0;
        acc[date].justified_absence += curr.justified
          ? 1 * curr?.id_session?.length || 0
          : 0;
        acc[date].unjustified_absence += curr.justified
          ? 0
          : 1 * curr?.id_session?.length || 0;
        acc[date].late_absence = curr?.late_absence || 0;

        // sessions
        const sessionEntries = (curr?.id_session || []).map((session: any) => ({
          id: session,
          abs: {
            id_absence: curr.id,
            courseVersionEDT: curr.CourseVersionEDT,
            justified: curr.justified ? 1 : 0,
            justificatif: curr.justificatif || null,
          },
        }));
        acc[date].sessions.push(...sessionEntries);

        return acc;
      }, {});

      // console.log("GROUP BY DATE: ", groupedByDate);

      // Convertir l'objet en tableau trié par date
      let formattedAbsences = Object.values(groupedByDate).sort(
        (a: any, b: any) =>
          new Date(a.date_course).getTime() - new Date(b.date_course).getTime(),
      );

      // console.log("FORMATED ABSENCE: ", formattedAbsences);

      const sortedPeriods = [...evaluationPeriods].sort(
        (a: any, b: any) =>
          dayjs(a.startDate).valueOf() - dayjs(b.startDate).valueOf(),
      );

      const totals = sortedPeriods.reduce(
        (acc: any, period: any, index: number) => {
          const key = `${period?.id}`;
          acc[key] = {
            total: sumForPeriod("total_absence", period, formattedAbsences),
            justified: sumForPeriod(
              "justified_absence",
              period,
              formattedAbsences,
            ),
            unjustified: sumForPeriod(
              "unjustified_absence",
              period,
              formattedAbsences,
            ),
            late: sumForPeriod("total_late", period, formattedLates),
          };
          return acc;
        },
        {},
      );

      setTotals(totals);

      // console.log("Formatted Data: ", formattedAbsences);
      setAbsences(formattedAbsences);
    } catch (error: any) {
      // console.log(
      //   "Erreur lors du chargement du rapport d'absence de l'étudiant ",
      //   error,
      // );
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Erreur lors du chargement du rapport d'absence",
      );
    } finally {
      setLoading({
        ...loading,
        main: false,
      });
    }
  };

  // Fonction pour charger toute les séances de l'année académique
  const fetchAllSessions = async () => {
    try {
      const response = await getSessionsByYear(
        selectedYear?.id,
        buildPermissionContext(Resource.STUDENT_ABSENCE, Action.READ),
      );
      setAllSessions(response.data || []);
    } catch (error: any) {
      // console.log("Erreur lors de la récupération des sessions:", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur est survenue, veuillez réessayer plus tard.",
      );
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date_course",
      key: "date_course",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000" } }),
      render: (date_course: string) =>
        new Date(date_course).toLocaleDateString("fr-FR", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
          weekday: "short",
        }),
    },
    {
      title: "Remarque d'absence",
      dataIndex: "absence_remark",
      key: "absence_remark",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000" } }),
      render: (absence_remark: string) => absence_remark || "Aucune",
    },
    {
      title: "Séances",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      children: allSessions.map((session: any, colIdx) => ({
        onHeaderCell: () => ({
          style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
        }),
        title: (
          <div style={{ textAlign: "center" }}>
            <div>{session.name}</div>
            <div style={{ fontSize: "0.75em", color: "#888" }}>
              {session.start_time?.slice(0, 5)} -{" "}
              {session.end_time?.slice(0, 5)}
            </div>
          </div>
        ),
        key: `session${session.id}`,
        width: 120,
        onCell: () => ({ style: { border: "1px solid #000" } }),
        render: (_: any, record: any, dayIndex: number) => {
          const sessionAbsence = record?.sessions?.find(
            (s: any) => s.id === session.id,
          );

          const sessionLate = lates?.find(
            (l: any) =>
              l.date_course === record.date_course &&
              l.id_session.some((id: string) => id === session.id),
          );
          return {
            props: {
              style: {
                border: "1px solid #000",
                backgroundColor: sessionAbsence
                  ? sessionAbsence?.abs?.justified
                    ? "rgba(0,128,0,0.2)"
                    : "rgba(255,0,0,0.2)"
                  : sessionLate?.total_late
                    ? "rgba(255,255,0,0.2)"
                    : "transparent",
              },
            },
            children: (
              <div className="text-center">
                {sessionAbsence ? (
                  <Popover
                    content={
                      <ReportAbsenceBubble
                        id_student={selectedStudent?.id_studentProfil || null}
                        absence={sessionAbsence}
                        open={popoverVisible}
                        allAbsences={absences}
                        allSessions={allSessions}
                        dayIndex={dayIndex}
                        sessionIndex={colIdx}
                        onSave={() => {
                          loadData();
                        }}
                        onCancel={() =>
                          setPopoverVisible({
                            [`${dayIndex}-${colIdx}`]: false,
                          })
                        }
                      />
                    }
                    title="Informations de l'absence"
                    trigger="click"
                    open={popoverVisible[`${dayIndex}-${colIdx}`] || false}
                    onOpenChange={(visible) =>
                      setPopoverVisible({ [`${dayIndex}-${colIdx}`]: visible })
                    }
                  >
                    {sessionAbsence?.abs?.justified ? (
                      <i
                        className="fas fa-check fs-4"
                        style={{
                          color: "green",
                          width: "100%",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      />
                    ) : (
                      <i
                        className="fas fa-times fs-4"
                        style={{
                          color: "red",
                          width: "100%",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      />
                    )}
                  </Popover>
                ) : sessionLate ? (
                  <div>
                    <Popover
                      content={
                        <div>
                          <strong>Retard</strong>
                          <br />
                          Cours:
                          {sessionLate?.CourseVersionEDT?.CourseClass?.Course
                            ?.Subject?.label || ""}
                          <br />
                          Temps de retard:{" "}
                          {sessionLate?.time
                            ? ` ${sessionLate?.time}`
                            : "Non préciser"}
                        </div>
                      }
                      title="Informations du retard"
                      trigger="hover"
                    >
                      <i
                        className="fas fa-clock fs-4"
                        style={{
                          color: "orange",
                          width: "100%",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      />
                    </Popover>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ),
          };
        },
      })),
    },
    {
      title: "Au total",
      dataIndex: "total_absence",
      key: "total_absence",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000" } }),
      render: (total_absence: number) => total_absence || 0,
    },
    {
      title: "Justifié",
      dataIndex: "justified_absence",
      key: "justified_absence",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000" } }),

      render: (justified_absence: number) => justified_absence || 0,
    },
    {
      title: "Non justifié",
      dataIndex: "unjustified_absence",
      key: "unjustified_absence",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000" } }),
      render: (unjustified_absence: number) => unjustified_absence || 0,
    },
    {
      title: "Retard (Count)",
      dataIndex: "late_absence",
      key: "late_absence",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000" } }),
      render: (late_absence: number) => late_absence || 0,
    },
  ];

  useEffect(() => {
    fetchAllClassByYear();
    fetchAllSessions();
  }, [selectedYear]);

  useEffect(() => {
    if (!selectedClass?.id) return;
    fetchStudentsByClass();
    fetchAllEvaluationPeriodByLevel();
  }, [selectedClass, selectedYear]);

  useEffect(() => {
    if (!selectedStudentId) return;
    setLoading({
      ...loading,
      main: true,
    });
    loadData();
  }, [selectedStudentId, selectedYear, evaluationPeriods]);

  const resumeColumns: any[] = [
    {
      title: "",
      dataIndex: "label",
      key: "label",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000", fontWeight: 600 } }),
      width: 140,
    },
    {
      title: "Au total",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      children: evaluationPeriods.map((period: any) => ({
        title: period?.label,
        dataIndex: `total-${period?.id}`,
        key: `total-${period?.id}`,
        onHeaderCell: () => ({
          style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
        }),
        onCell: () => ({ style: { border: "1px solid #000" } }),
        width: 120,
      })),
    },
    {
      title: "Excusé",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      children: evaluationPeriods.map((period: any) => ({
        title: period?.label,
        dataIndex: `ex-${period?.id}`,
        key: `ex-${period?.id}`,
        onHeaderCell: () => ({
          style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
        }),
        onCell: () => ({ style: { border: "1px solid #000" } }),
        width: 120,
      })),
    },
    {
      title: "Inexcusé",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      children: evaluationPeriods.map((period: any) => ({
        title: period?.label,
        dataIndex: `inex-${period?.id}`,
        key: `inex-${period?.id}`,
        onHeaderCell: () => ({
          style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
        }),
        onCell: () => ({ style: { border: "1px solid #000" } }),
        width: 120,
      })),
    },
  ];

  const resumeData = [
    {
      key: "absent",
      label: "Absent",
      ...evaluationPeriods.reduce((acc: any, period: any) => {
        acc[`total-${period.id}`] = totals?.[period.id]?.total ?? 0;
        acc[`ex-${period.id}`] = totals?.[period.id]?.justified ?? 0;
        acc[`inex-${period.id}`] = totals?.[period.id]?.unjustified ?? 0;
        return acc;
      }, {}),
    },
  ];

  const lateColumns = [
    {
      title: "",
      dataIndex: "label",
      key: "label",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000", fontWeight: 600 } }),
      width: 200,
    },
    ...evaluationPeriods.map((period: any) => ({
      title: period?.label,
      dataIndex: `${period?.id}`,
      key: `${period?.id}`,
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000" } }),
      width: 150,
    })),
  ];

  const lateData = [
    {
      key: "late",
      label: "Late (count)",
      ...evaluationPeriods.reduce((acc: any, period: any) => {
        acc[period.id] = totals?.[period.id]?.late ?? 0;
        return acc;
      }, {}),
    },
  ];

  const typeColumns = [
    {
      title: "",
      dataIndex: "label",
      key: "label",
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000", fontWeight: 600 } }),
      width: 200,
    },
    ...evaluationPeriods.map((period: any) => ({
      title: period?.label,
      dataIndex: `${period?.id}`,
      key: `${period?.id}`,
      onHeaderCell: () => ({
        style: { backgroundColor: "#d6e4ff", border: "1px solid #000" },
      }),
      onCell: () => ({ style: { border: "1px solid #000" } }),
      width: 150,
    })),
  ];

  const typeData = [
    {
      key: "coursExcusee",
      label: "Cours excusée",
      ...evaluationPeriods.reduce((acc: any, period: any) => {
        acc[period.id] = totals?.[period.id]?.justified ?? 0;
        return acc;
      }, {}),
    },
    {
      key: "somme",
      label: "Somme",
      ...evaluationPeriods.reduce((acc: any, period: any) => {
        acc[period.id] = totals?.[period.id]?.total ?? 0;
        return acc;
      }, {}),
    },
  ];

  // Fonction pour générer le rapport d'absence annuel
  const generateAbsenceReport = async () => {
    try {
      if (!selectedStudent || !selectedYear) {
        toast.error("Veuillez sélectionner un étudiant et une année scolaire.");
        return;
      }
      const pdfBlob = await generateAbsencePdfByYear(
        selectedStudent.id_studentProfil,
        selectedYear.id,
      );
      setPdfBlobUrl(URL.createObjectURL(pdfBlob));
      setAnnuelReportVisible(true);
      toast.success("Rapport généré avec succès.");
    } catch (error: any) {
      // console.log("Erreur lors de la génération du rapport:", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur est survenue, veuillez réessayer plus tard.",
      );
    } finally {
      setLoading({
        ...loading,
        annuel: false,
      });
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div
          className="content container-fluid d-flex flex-column"
          style={{ height: "calc(100vh - 60px)" }}
        >
          <div
            className="sticky-top bg-white d-md-flex d-block align-items-center justify-content-between mb-3"
            style={{ zIndex: 1020, top: 0 }}
          >
            {/* MENU DASHBOARD */}
            <DashboardMenu />

            {/* SELECT + ACTIONS */}
            {/* Select Classe */}
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="col-md-12 col-lg-12">
                <div className="card h-100">
                  <div className="card-body p-3">
                    <label className="form-label fw-bold">
                      Sélectionner une classe
                    </label>
                    <Select
                      className="w-100"
                      placeholder="Choisir une classe"
                      value={selectedClass?.id}
                      onChange={(value) =>
                        setSelectedClass(
                          allClass.find((c: any) => c.id === value),
                        )
                      }
                      options={allClass.map((cls) => ({
                        value: cls.id,
                        label: `${cls?.Level?.abbreviation} - ${cls.label}`,
                      }))}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!selectedYear?.statut && <InfosAlertYearDisabled />}
          <div
            className="row flex-grow-1"
            style={{ minHeight: 0, height: "100%", overflow: "hidden" }}
          >
            <div
              className={
                selectedStudentId
                  ? "col-12 col-md-5 col-lg-4 d-flex flex-column"
                  : "col-12 d-flex flex-column"
              }
              style={{ minHeight: 0, maxHeight: "100%" }}
            >
              {loading.students && !allStudents.length ? (
                <div className="text-center p-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Chargement...</span>
                  </div>
                </div>
              ) : allStudents.length === 0 ? (
                <div className="card">
                  <div className="card-body text-center p-5">
                    <i className="ti ti-users fs-1 mb-3 text-muted" />
                    <h5>Aucun étudiant trouvé</h5>
                    <p className="text-muted">
                      Sélectionnez une classe pour voir les étudiants.
                    </p>
                  </div>
                </div>
              ) : (
                <div className="flex-grow-1 p-2" style={{ overflowY: "auto" }}>
                  <div
                    className={`row g-3 ${
                      selectedStudentId
                        ? "row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2"
                        : "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5"
                    }`}
                  >
                    {allStudents.map((student) => {
                      const sid = student?.StudentProfil?.id ?? student?.id;
                      const firstname =
                        student?.StudentProfil?.firstname ?? student?.firstname;
                      const lastname =
                        student?.StudentProfil?.lastname ?? student?.lastname;
                      const matricule =
                        student?.StudentProfil?.matricule ?? student?.matricule;
                      const levelAbbr =
                        student?.Registrations?.[0]?.Class?.Level
                          ?.abbreviation ?? selectedClass?.Level?.abbreviation;
                      const classLabel =
                        student?.Registrations?.[0]?.Class?.label ??
                        selectedClass?.label;
                      const classAbrev =
                        student?.Registrations?.[0]?.Class?.abbreviation ??
                        selectedClass?.abbreviation;
                      const isSelected =
                        (selectedStudent?.StudentProfil?.id ??
                          selectedStudent?.id) === sid;
                      return (
                        <div key={sid} className="col">
                          <div
                            className={`card h-100 cursor-pointer transition-all ${
                              isSelected
                                ? "border-primary border-2 shadow"
                                : "hover-shadow"
                            }`}
                            onClick={() => setSelectedStudent(student)}
                            style={{
                              cursor: "pointer",
                              transition: "all 0.2s",
                            }}
                          >
                            <div className="card-body text-center">
                              <div className="mb-1">
                                <div className="mb-3 position-relative d-inline-block">
                                  <span className="avatar avatar-xl rounded-circle">
                                    <Avvvatars
                                      value={`${firstname?.charAt(0) || ""}${
                                        lastname?.charAt(0) || ""
                                      }`}
                                      style="character"
                                      size={60}
                                    />
                                  </span>
                                </div>
                              </div>
                              <h6 className="fw-bold mb-1">
                                {firstname} {lastname}
                              </h6>
                              <p className="text-muted small mb-1">
                                <strong>
                                  {levelAbbr} - {classAbrev}
                                </strong>{" "}
                                | {matricule}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {selectedStudentId && (
              <div
                className="col-12 col-md-7 col-lg-8 d-flex flex-column"
                style={{ minHeight: 0, maxHeight: "100%" }}
              >
                <div
                  className="flex-grow-1"
                  style={{ overflowY: "auto", minHeight: 0 }}
                >
                  {/* TITRE + BOUTON EXPORT */}
                  <div className="mt-3 mb-3 d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">
                      Rapport Absence:{" "}
                      {selectedStudent?.StudentProfil?.firstname ??
                        selectedStudent?.firstname}{" "}
                      {selectedStudent?.StudentProfil?.lastname ??
                        selectedStudent?.lastname}{" "}
                      ( {selectedClass?.Level?.label} - {selectedClass?.label} )
                    </h4>

                    <Button
                      style={{
                        padding: "10px 16px",
                        background: "#ffe6d1",
                        borderColor: "#ff7c00",
                        color: "#b35900",
                        width: "fit-content",
                        lineHeight: 1.2,
                      }}
                      onClick={() => {
                        setLoading({ ...loading, annuel: true });
                        generateAbsenceReport();
                      }}
                    >
                      {loading.annuel ? (
                        <Spin size="small" />
                      ) : (
                        <i className="ti ti-printer me-2" />
                      )}
                      <span style={{ fontSize: "0.9rem" }}>Imprimer</span>
                    </Button>
                  </div>

                  {loading.main ? (
                    <div className="text-center py-5">
                      <Spin size="large" />
                    </div>
                  ) : absences.length === 0 && lates.length === 0 ? (
                    <>
                      <div className="text-center py-5">
                        <span className="text-danger">
                          Aucune absence enregistrée pour cet étudiant cette
                          année.
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <Table
                        columns={columns}
                        dataSource={(() => {
                          const merged = new Map<string, any>();
                          absences.forEach((abs) => {
                            merged.set(abs.date_course, { ...abs });
                          });
                          lates.forEach((late) => {
                            const existing = merged.get(late.date_course);
                            if (existing) {
                              existing.late_absence =
                                (existing.late_absence || 0) +
                                (late.total_late || 0);
                            } else {
                              merged.set(late.date_course, {
                                ...late,
                                late_absence: late.total_late || 0,
                              });
                            }
                          });
                          return Array.from(merged.values()).sort(
                            (a, b) =>
                              new Date(a.date_course).getTime() -
                              new Date(b.date_course).getTime(),
                          );
                        })()}
                        pagination={false}
                        rowKey={(record) => record.id}
                      />
                      <div
                        style={{
                          background: "#d6e4ff",
                          padding: "8px",
                          fontWeight: 600,
                          margin: "30px 0px 10px 0px",
                          borderLeft: "5px solid black",
                        }}
                      >
                        Résumé
                      </div>
                      <Table
                        columns={resumeColumns}
                        dataSource={resumeData}
                        pagination={false}
                        rowKey={(record) => record.key}
                      />
                      <div
                        style={{
                          background: "#d6e4ff",
                          padding: "8px",
                          fontWeight: 600,
                          margin: "30px 0px 10px 0px",
                          borderLeft: "5px solid black",
                        }}
                      >
                        En retard
                      </div>
                      <Table
                        columns={lateColumns}
                        dataSource={lateData}
                        pagination={false}
                        rowKey={(record) => record.key}
                      />
                      <div
                        style={{
                          background: "#d6e4ff",
                          padding: "8px",
                          fontWeight: 600,
                          margin: "30px 0px 10px 0px",
                          borderLeft: "5px solid black",
                        }}
                      >
                        Type d'absence
                      </div>
                      <Table
                        columns={typeColumns}
                        dataSource={typeData}
                        pagination={false}
                        rowKey={(record) => record.key}
                        onRow={(record) => ({
                          style:
                            record.key === "coursExcusee"
                              ? { backgroundColor: "rgba(0,128,0,0.15)" }
                              : {},
                        })}
                      />
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <AnnuelAbsenceReportApercuModal
        show={annuelReportVisible}
        metaData={{
          Student: allStudents.find((s) => s.id === selectedStudent),
          pdfBlobUrl,
          selectedYear: selectedYear,
        }}
        onClose={() => setAnnuelReportVisible(false)}
      />

      <AnnuelAbsenceReportApercuModal
        show={semesterReportVisible}
        metaData={{
          Student: allStudents.find((s) => s.id === selectedStudent),
          pdfBlobUrl,
          period: selectedPeriod,
        }}
        onClose={() => setSemesterReportVisible(false)}
      />
    </>
  );
};

export default StudentAbsencePage;
